import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { handleFilter } from '../../store/actions';
import { storage } from '../../config';

import Header from './Header';

export const mapStateToProps = ({ favorites, viewer, router }) => {
  let areaToShow = 'states';
  const areasToShow = viewer.areaSettings.areasToShow;
  if (areasToShow && areasToShow.indexOf('States') === -1) {
    areaToShow = areasToShow.length === 0 ? null : areasToShow[0].toLowerCase();
  }

  return {
    ...viewer.visibleSections,
    activeColor: viewer.activeColor,
    activeOnLoad: viewer.activeOnLoad,
    logoUrl: viewer.logo
      ? `${storage.cloudStoragePath}/${viewer.logo}`
      : '',
    logoLink: viewer.logoLink || '',
    hasFavorites: favorites.folders.savedFolders.some(
      folder => (folder.buildings && folder.buildings.length) ||
                (folder.sites && folder.sites.length) ||
                (folder.states && folder.states.length) ||
                (folder.regions && folder.regions.length) ||
                (folder.counties && folder.counties.length) ||
                (folder.communities && folder.communities.length),
    ),
    pathname: router.location.pathname,
    search: router.location.search,
    searchType: router.location.pathname.split('/')[1] === 'sites' ? 'sites' : 'buildings',
    areaToShow,
    hideLogo: viewer.hideLogo,
    showSearchAndAppliedFilters: viewer.showSearchAndAppliedFilters,
  };
};

export const mapDispatchToProps = dispatch => ({
  handleSearchClick: name => dispatch(handleFilter('', name)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));



// WEBPACK FOOTER //
// ./src/components/Header/HeaderWrapper.js